import React from "react";
import { Navigate } from "react-router-dom";
import POExceptionMgmtBuyer from "./POExceptionMgmtBuyer";
import POExceptionMgmtSupplier from "./POExceptionMgmtSupplier";

const POExceptionManagement = () => {
    const userRole = localStorage.getItem("userRole");

    if (userRole === "Global Planner" || userRole === "Regional Planner" || userRole === "Global Viewer" || userRole === "Regional Viewer") {
        return <POExceptionMgmtBuyer />;
    }

    if (userRole === "Supplier Planner" || userRole === "Supplier Admin") {
        return <POExceptionMgmtSupplier />;
    }

    if (userRole === "App Admin") {
        const hasPOSupplierUser = localStorage.getItem("hasPOSupplierUser") === "true";
        return hasPOSupplierUser ? <POExceptionMgmtSupplier /> : <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;

};

export default POExceptionManagement;